const Label = ({ className = '', children, ...restProps }) => {
   const classes = ['label'].concat(className.split(' '));
   return <label className={classes.join(' ')} {...restProps}>{children}</label>;
};

export default Label;
